import { useAuthentication } from '@ecosystem/newron-client-lib';
import React, { useContext, useEffect, useState } from 'react';

import { UpsellName, UpsellStatus } from '../../common';
import { RetailKADMessageResponse, postUpsellAnalytics } from '../../services/Market.service';
import { UpsellContext } from '../../state';
import { setActiveSlideIndex } from '../../state/action';
import { getRetailUpsellSlides } from '../../utils/getRetailKADUpsell';
import { Notification } from '../notification';
import { TargetedUpsellMessage } from '../targeted-upsell-message/TargetedUpsellMessage';
import { UpsellModal } from '../upsell-modal';

interface RetailKADUpsellProps {
  retailKADMessage?: RetailKADMessageResponse | null;
}

export const RetailKADUpsell = ({ retailKADMessage }: RetailKADUpsellProps): JSX.Element => {
  const [showRetailUpsellModal, setShowRetailUpsellModal] = useState<boolean>(true);
  const { user, getAccessToken } = useAuthentication();
  const { dispatch } = useContext(UpsellContext);
  const RETAIL_KAD_SLIDES = getRetailUpsellSlides();

  const onCloseHandler = (value: boolean) => {
    setShowRetailUpsellModal(value);
  };

  const onCloseTrack = () => {
    dispatch(setActiveSlideIndex(0));
  };

  useEffect(() => {
    (async () => {
      if (retailKADMessage) {
        const analyticsData = {
          cell: retailKADMessage.countryCode + '-' + retailKADMessage.itemGroupCode,
          userId: user?.userId,
          upsellName: UpsellName.RETAIL_KAD,
          upsellStatus: UpsellStatus.UPSELL_SHOWN,
        };

        const token = await getAccessToken();
        await postUpsellAnalytics(token, analyticsData);
      }
    })();
  }, [getAccessToken, retailKADMessage, user?.userId]);

  return (
    <>
      {showRetailUpsellModal && (
        <TargetedUpsellMessage
          setShowRetailUpsellModal={setShowRetailUpsellModal}
          onClose={() => onCloseHandler(false)}
          showRetailUpsellModal={showRetailUpsellModal}
          retailKADUpsellMessage={retailKADMessage}
        />
      )}
      <Notification />
      <UpsellModal slides={RETAIL_KAD_SLIDES} size="big" onCloseTrack={onCloseTrack} />
    </>
  );
};
